import type { IAccount } from "@apis/accounts/types"
import { serializePlanSection } from "@pages/AccountPage/utils/accountInfoSerializerSchema"
import { useAccountInvoicesSerializer } from "@pages/AccountPage/utils/useAccountInvoicesSerializerSchema"
import { serializeProspectData } from "@pages/AccountPage/utils/accountProspectSerializerSchema"
import { serializePlanRewardsData } from "@pages/AccountPage/utils/serializePlanRewardsData"

export const useTransformAccountData = (data: IAccount) => ({
  planSection: serializePlanSection(data),
  prospectData: serializeProspectData(data),
  invoiceData: useAccountInvoicesSerializer(data),
  planRewardsData: serializePlanRewardsData(data),
})
